import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./i18n";
import { safeGetItem, safeSetItem } from "./lib/storage";

const LanguageContext = createContext(null);

const getInitial = () => {
  const saved = typeof window !== "undefined" ? safeGetItem("skystart_lang") : null;
  return saved && translations[saved] ? saved : "pl";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitial);

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    safeSetItem("skystart_lang", code);
    document.documentElement.lang = code;
  }, []);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
